// extracted by mini-css-extract-plugin
export var borderTop = "_w-3";
export var linkIcon = "_w-5";
export var linkIconSm = "_w-6";
export var linkOutCard = "_w-7 _w-4";
export var linkRow = "_w-2";
export var pageContainer = "_w-1";
export var providerIcon = "_w-8";
export var roundedBorder = "_w-4";
export var settingsContent = "_w-0";